// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"21":"1b10b54b18a941ca76f7","66":"19d0ac3557fd90bd0745","364":"bfb86e25f4ecc7713f7d","540":"ca41adb8120dd5fd69ea","961":"cd288505b561cc147b86"}[chunkId] + ".js";
};